import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import Withdrawal_Payment_Reports from "./Components/Withdrawal/Withdrawal_Payment_Reports";
import Withdrawal_Pending_List from "./Components/Withdrawal/Withdrawal_Pending_List";
import Login from "./Components/Login/Login";
import OPT_Confirm from "./Components/Login/OPT_Confirm";
import WithdrawlStart_Stop from "./Components/Member/WithdrawlStart_Stop";
import Message from "./Components/Dashboard Message/Message";
import MessageHistory from "./Components/Dashboard Message/MessageHistory";
import ProtectedRoute from "./Redux/actions/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Buy from "./Components/Trading/Buy";
import Sell from "./Components/Trading/Sell";
import TrandingWithdrawHistory from "./Components/Member/TrandingWithdrawHistory";
import Staking_Claim_History from "./Components/Member/Staking_Claim_History";
import Edit_details from "./Components/Member/Edit_details";
import HelpDesk from "./Components/HelpDesk/HelpDesk";
import Reply from "./Components/HelpDesk/Reply";
import Commission from "./Components/HelpDesk/Commission";
import LoginHistory from "./Components/HelpDesk/LoginHistory";
// import ApprovedKyc  from "./Components/Kyc/ApprovedKyc";
// import PendingKyc from "./Components/Kyc/PendingKyc";
import Manage_subadmin from "./Components/Sub_Admin/Manage_subadmin";
import Subadmin_rights from "./Components/Sub_Admin/Subadmin_rights";
import Edit_subAdmin from "./Components/Sub_Admin/Edit_subAdmin";
import Add_subAdmin from "./Components/Sub_Admin/Add_subAdmin";
import My_Team from "./Components/Team_Reports/My team";
import Contact from "./Components/Contact/Contact";
import Add_HomePageCoin from "./Components/HomePageCoin/Add_HomePageCoin";
import HomePageCoinDetails from "./Components/HomePageCoin/HomePageCoinDetails";
import Update_HomePageCoin from "./Components/HomePageCoin/Update_HomePageCoin";
import RequestToken from "./Components/Request Token/RequestToken";
import RequestTokenUpdate from "./Components/Request Token/RequestTokenUpdate";
import RequestTokenPaid from "./Components/Request Token/RequestTokenPaid";
import RequestTokenCancel from "./Components/Request Token/RequestTokenCancel";
import Active_Member from "./Components/Member/ACTIVE_MEMBER_LIST";
import Level_detail from "./Components/Team_Reports/Level_detail";
import Direct_team from "./Components/Team_Reports/Direct_team";
import ActivationByAdmin from "./Components/Activation/ActivationByAdmin";
import RetopupHistory from "./Components/Member/RetopupHistory";
import All_member from "./Components/Member/All_member";
import UpgradeID from "./Components/Activation/UpgradeID";
import ActivationUHistory from "./Components/Activation/ActivationUHistory";
import DirectLegBusiness from "./Components/Team_Reports/DirectLegBusiness";
import AddPowerleg from "./Components/Power Leg/AddPowerleg";
import PowerlegHis from "./Components/Power Leg/PowerlegHis";
import RoiRate from "./Components/Power Leg/RoiRate";
import LevelIncome from "./Components/Income Reports/LevelIncome";
import TeamReward_income from "./Components/Income Reports/TeamReward_income";
import Total_incomeReport from "./Components/Income Reports/Total_incomeReport";
import RoiIncome from "./Components/Income Reports/RoiIncome";
import RoiIncomeReward from "./Components/Income Reports/RoiIncomeReward";
import ClosedHelpDesk from "./Components/HelpDesk/ClosedHelpDesk";
import SubadminHistory from "./Components/Sub_Admin/SubadminHistory";
import InvestmentSummary from "./Components/Member/InvestmentSummary";
import Member_Details from "./Components/Member/Member_Details";
import DirectIncome from "./Components/Income Reports/DirectIncome";
import Upgrade_MEMBER_LIST from "./Components/Member/Upgrade_MEMBER_LIST";
import TeamRewardPaid from "./Components/Income Reports/TeamRewardPaid";
import Withdrawal_Pending_List_nonworking from "./Components/Withdrawal/PendingClaimActvationHistory";
import Withdrawal_Payment_Reports_nonworking from "./Components/Withdrawal/PaidClaimActvationHistory";
import PendingClaimActvationHistory from "./Components/Withdrawal/PendingClaimActvationHistory";
import PaidClaimActvationHistory from "./Components/Withdrawal/PaidClaimActvationHistory";
import ActivationHistoryUser from "./Components/Activation/ActivationHistoryUser";
import BinaryIncome from "./Components/Income Reports/BinaryIncome";
import UsdtQrDetails from "./Components/Fund/UsdtQrDetails";
import PendingFundRequest from "./Components/Fund/PendingFundRequest";
import FundRequestHistory from "./Components/Fund/FundRequestHistory";
import PendingTravel from "./Components/TravelPoints/PendingTravel";
import TravelPointsHistory from "./Components/TravelPoints/TravelPointsHistory";
import MembershipActive_LIST from "./Components/Member/MembershipActive_LIST";
import MembershipRefund from "./Components/Income Reports/MembershipRefund";
import BankBonusDetails from "./Components/QR Details/BankBonusDetails";
import PendingBAnkRequest from "./Components/QR Details/PendingBAnkRequest";
import BankContractHistory from "./Components/QR Details/BankContractHistory";
import ActivationUHistoryTravel from "./Components/Activation/ActivationUHistoryTravel";
import ActivationHistoryUserTravel from "./Components/Activation/ActivationHistoryUserTravel";
import CashbackIncomeHistory from "./Components/CashbackIncome/CashbackIncomeHistory";
import CashbackIncomeRequest from "./Components/CashbackIncome/CashbackIncomeRequest";
import Withdrawal_Pending_List_USDT from "./Components/Withdrawal/Withdrawal_Pending_List_USDT";
import Withdrawal_Payment_Reports_Usdt from "./Components/Withdrawal/Withdrawal_Payment_Reports_Usdt";
import FlushIncome from "./Components/Income Reports/FlushIncome";
import PendingGetHelp from "./Components/Team_Reports/PendingGetHelp";
import PendingProvideHelp from "./Components/Team_Reports/PendingProvideHelp";
import ReceivedGetHelp from "./Components/Team_Reports/ReceivedGetHelp";
import PaidProvideHelp from "./Components/Team_Reports/PaidProvideHelp";
import CancelGetHelp from "./Components/Team_Reports/CancelGetHelp";
import CancelProvideHelp from "./Components/Team_Reports/CancelProvideHelp";
import News from "./Components/News/News";
import UpdateLink from "./Components/Team_Reports/UpdateLink";
import ExpiredLink from "./Components/Team_Reports/ExpiredLink";
import PhReceiver from "./Components/Team_Reports/PhReceiver";
import GenerateLink from "./Components/Member/GenerateLink";
import GenerateLinkwithdrawal from "./Components/Member/GenerateLinkwithdrawal";
import GenerateLink500 from "./Components/Member/GenerateLink500";
import GHRequesttoAdmin from "./Components/Power Leg/GHRequesttoAdmin";
import OnlineEpinRequestHistory from "./Components/QR Details/OnlineEpinRequestHistory";
import GatewayEpinRequestHistory from "./Components/QR Details/GatewayEpinRequestHistory";
import PHRequesttoAdmin from "./Components/Power Leg/PHRequesttoAdmin";
import UsedEpin from "./Components/Power Leg/UsedEpin";
import UnusedPin from "./Components/Power Leg/UnusedPin";
import PHRequestAdminHis from "./Components/Power Leg/PHRequestAdminHis";
import GHRequestAdminHis from "./Components/Power Leg/GHRequestAdminHis";
import LinkHistory from "./Components/Team_Reports/LinkHistory";
import WithdrawalLinkHistory from "./Components/Team_Reports/WithdrawalLinkHistory";
import EpinDetailsuserwise from "./Components/Power Leg/EpinDetailsuserwise";

function App() {
  // useEffect(() => {
  //   const handleContextMenu = (event) => {
  //     event.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);

  //   document.addEventListener("keydown", (e) => {
  //     if (
  //       (e.ctrlKey &&
  //         (e.key === "I" ||
  //           e.key === "i" ||
  //           e.key === "u" ||
  //           e.key === "U" ||
  //           e.key === "J" ||
  //           e.key === "j" ||
  //           e.key === "C" ||
  //           e.key === "c")) ||
  //       e.key === "F12"
  //     ) {
  //       e.preventDefault();
  //     }
  //   });

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //   };
  // }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route />
          <Route exact path="/" element={<Login />} />
          <Route exact path="/OPT_Confirm" element={<OPT_Confirm />} />
          <Route
            exact
            path="/Dashboard"
            element={<ProtectedRoute component={Dashboard} />}
          />
          <Route
            exact
            path="/Allmember"
            element={<ProtectedRoute component={All_member} />}
          />
          <Route
            exact
            path="/Dashboard_Message"
            element={<ProtectedRoute component={Message} />}
          />
          <Route
            exact
            path="/MessageHistory"
            element={<ProtectedRoute component={MessageHistory} />}
          />

          <Route
            exact
            path="/Member_Details"
            element={<ProtectedRoute component={Member_Details} />}
          />
          <Route
            exact
            path="/WithdrawlStart_Stop"
            element={<ProtectedRoute component={WithdrawlStart_Stop} />}
          />
          <Route
            exact
            path="/ActiveMember"
            element={<ProtectedRoute component={Active_Member} />}
          />
          <Route
            exact
            path="/MembershipActiveMember"
            element={<ProtectedRoute component={MembershipActive_LIST} />}
          />
          <Route
            exact
            path="/upgradeMember"
            element={<ProtectedRoute component={Upgrade_MEMBER_LIST} />}
          />
          <Route
            exact
            path="/BusinessSummary"
            element={<ProtectedRoute component={InvestmentSummary} />}
          />

          <Route
            exact
            path="/RetopupHistory"
            element={<ProtectedRoute component={RetopupHistory} />}
          />

          <Route
            exact
            path="/Activation"
            element={<ProtectedRoute component={ActivationByAdmin} />}
          />

          <Route
            exact
            path="/upgradeid"
            element={<ProtectedRoute component={UpgradeID} />}
          />
          <Route
            exact
            path="/Activationhistory"
            element={<ProtectedRoute component={ActivationUHistory} />}
          />
          <Route
            exact
            path="/ActivationUHistoryTravel"
            element={<ProtectedRoute component={ActivationUHistoryTravel} />}
          />

          <Route
            exact
            path="/roirate"
            element={<ProtectedRoute component={RoiRate} />}
          />
          <Route
            exact
            path="/addpower"
            element={<ProtectedRoute component={AddPowerleg} />}
          />

          <Route
            exact
            path="/powerhistory"
            element={<ProtectedRoute component={PowerlegHis} />}
          />

          <Route
            exact
            path="/FundRequestHistory"
            element={<ProtectedRoute component={FundRequestHistory} />}
          />

          <Route
            exact
            path="/Withdrawal_History"
            element={<ProtectedRoute component={Withdrawal_Payment_Reports} />}
          />
          <Route
            exact
            path="/Withdrawal_Payment_Reports_Usdt"
            element={
              <ProtectedRoute component={Withdrawal_Payment_Reports_Usdt} />
            }
          />
          <Route
            exact
            path="/PaidClaimActvationHistory"
            element={<ProtectedRoute component={PaidClaimActvationHistory} />}
          />

          <Route
            exact
            path="/Pending_Withdrawal"
            element={<ProtectedRoute component={Withdrawal_Pending_List} />}
          />

          <Route
            exact
            path="/Withdrawal_Pending_List_USDT"
            element={
              <ProtectedRoute component={Withdrawal_Pending_List_USDT} />
            }
          />

          <Route
            exact
            path="/PendingClaimActvationHistory"
            element={
              <ProtectedRoute component={PendingClaimActvationHistory} />
            }
          />

          <Route
            exact
            path="/Buy"
            element={<ProtectedRoute component={Buy} />}
          />
          <Route
            exact
            path="/Sell"
            element={<ProtectedRoute component={Sell} />}
          />
          <Route
            exact
            path="/DepositeHistory"
            element={<ProtectedRoute component={Staking_Claim_History} />}
          />

          <Route
            exact
            path="/Cancel_Withdrawal"
            element={<ProtectedRoute component={TrandingWithdrawHistory} />}
          />
          <Route
            exact
            path="/Edit_Details"
            element={<ProtectedRoute component={Edit_details} />}
          />
          <Route
            exact
            path="/HelpDesk"
            element={<ProtectedRoute component={HelpDesk} />}
          />
          <Route
            exact
            path="/ClosedHelpDesk"
            element={<ProtectedRoute component={ClosedHelpDesk} />}
          />
          <Route
            exact
            path="/Reply"
            element={<ProtectedRoute component={Reply} />}
          />
          <Route
            exact
            path="/PendingReward"
            element={<ProtectedRoute component={RequestToken} />}
          />
          <Route
            exact
            path="/PaidRewardHistory"
            element={<ProtectedRoute component={RequestTokenPaid} />}
          />
          <Route
            exact
            path="/RequestTokenUpdate"
            element={<ProtectedRoute component={RequestTokenUpdate} />}
          />
          <Route
            exact
            path="/Commission_Report"
            element={<ProtectedRoute component={Commission} />}
          />
          <Route
            exact
            path="/LoginHistory"
            element={<ProtectedRoute component={LoginHistory} />}
          />
          {/* <Route exact path="/ApprovedKyc" element={<ProtectedRoute component={ApprovedKyc}/>} />
        <Route exact path="/PendingKyc" element={<ProtectedRoute component={PendingKyc}/>} /> */}
          <Route
            exact
            path="/Manage_subadmin"
            element={<ProtectedRoute component={Manage_subadmin} />}
          />
          <Route
            exact
            path="/Subadmin_rights"
            element={<ProtectedRoute component={Subadmin_rights} />}
          />
          <Route
            exact
            path="/Edit_SubAdmin"
            element={<ProtectedRoute component={Edit_subAdmin} />}
          />
          <Route
            exact
            path="/Add_SubAdmin"
            element={<ProtectedRoute component={Add_subAdmin} />}
          />

          <Route
            exact
            path="/LevelIncome"
            element={<ProtectedRoute component={LevelIncome} />}
          />

          <Route
            exact
            path="/BinaryIncome"
            element={<ProtectedRoute component={BinaryIncome} />}
          />

          <Route
            exact
            path="/FlushIncome"
            element={<ProtectedRoute component={FlushIncome} />}
          />

          <Route
            exact
            path="/RoiIncome"
            element={<ProtectedRoute component={RoiIncome} />}
          />

          <Route
            exact
            path="/RoiIncomeReward"
            element={<ProtectedRoute component={RoiIncomeReward} />}
          />

          <Route
            exact
            path="/TeamReward_income"
            element={<ProtectedRoute component={TeamReward_income} />}
          />

          <Route
            exact
            path="/TeamRewardPaid"
            element={<ProtectedRoute component={TeamRewardPaid} />}
          />
          <Route
            exact
            path="/DirectIncome"
            element={<ProtectedRoute component={DirectIncome} />}
          />

          <Route
            exact
            path="/Total_incomeReport"
            element={<ProtectedRoute component={Total_incomeReport} />}
          />

          {/* <Route exact path="/Add_MarketCoin" element={<ProtectedRoute component={Add_MarketCoin}/>} /> 
        <Route exact path="/MarketCoinHistory" element={<ProtectedRoute component={MarketCoinHistory}/>} /> 
        <Route exact path="/Update_Coin_Details" element={<ProtectedRoute component={UpdateCoin}/>}/> */}
          <Route
            exact
            path="/My_Team"
            element={<ProtectedRoute component={My_Team} />}
          />

          <Route
            exact
            path="/myreferrals"
            element={<ProtectedRoute component={Direct_team} />}
          />
          <Route
            exact
            path="/PendingGetHelp"
            element={<ProtectedRoute component={PendingGetHelp} />}
          />
          <Route
            exact
            path="/PhReceiver"
            element={<ProtectedRoute component={PhReceiver} />}
          />
          <Route
            exact
            path="/PendingProvideHelp"
            element={<ProtectedRoute component={PendingProvideHelp} />}
          />

          <Route
            exact
            path="/ReceivedGetHelp"
            element={<ProtectedRoute component={ReceivedGetHelp} />}
          />
          <Route
            exact
            path="/PaidProvideHelp"
            element={<ProtectedRoute component={PaidProvideHelp} />}
          />

          <Route
            exact
            path="/CancelGetHelp"
            element={<ProtectedRoute component={CancelGetHelp} />}
          />
          <Route
            exact
            path="/CancelProvideHelp"
            element={<ProtectedRoute component={CancelProvideHelp} />}
          />

          <Route
            exact
            path="/Level_detail"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/DirectLegBusiness"
            element={<ProtectedRoute component={DirectLegBusiness} />}
          />

          <Route
            exact
            path="/levelDetails"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/Contact_Query"
            element={<ProtectedRoute component={Contact} />}
          />
          <Route
            exact
            path="/Add_HomePageCoin"
            element={<ProtectedRoute component={Add_HomePageCoin} />}
          />
          <Route
            exact
            path="/HomePageCoinDetails"
            element={<ProtectedRoute component={HomePageCoinDetails} />}
          />
          <Route
            exact
            path="/Update_HomePageCoin"
            element={<ProtectedRoute component={Update_HomePageCoin} />}
          />
          <Route
            exact
            path="/RequestTokenCancel"
            element={<ProtectedRoute component={RequestTokenCancel} />}
          />

          <Route
            exact
            path="/SubadminHistory"
            element={<ProtectedRoute component={SubadminHistory} />}
          />
          <Route
            exact
            path="/ActivationHistoryUser"
            element={<ProtectedRoute component={ActivationHistoryUser} />}
          />
          <Route
            exact
            path="/ActivationHistoryUserTravel"
            element={<ProtectedRoute component={ActivationHistoryUserTravel} />}
          />
          <Route
            exact
            path="/UsdtQrDetails"
            element={<ProtectedRoute component={UsdtQrDetails} />}
          />
          <Route
            exact
            path="/PendingFundRequest"
            element={<ProtectedRoute component={PendingFundRequest} />}
          />
          <Route
            exact
            path="/PendingTravel"
            element={<ProtectedRoute component={PendingTravel} />}
          />
          <Route
            exact
            path="/TravelPointsHistory"
            element={<ProtectedRoute component={TravelPointsHistory} />}
          />
          <Route
            exact
            path="/MembershipRefund"
            element={<ProtectedRoute component={MembershipRefund} />}
          />
          <Route
            exact
            path="/bankDetails"
            element={<ProtectedRoute component={BankBonusDetails} />}
          />
          <Route
            exact
            path="/PendingbankRequest"
            element={<ProtectedRoute component={PendingBAnkRequest} />}
          />
          <Route
            exact
            path="/BankHistory"
            element={<ProtectedRoute component={BankContractHistory} />}
          />
          <Route
            exact
            path="/OnlineEpinRequestHistory"
            element={<ProtectedRoute component={OnlineEpinRequestHistory} />}
          />
          <Route
            exact
            path="/GatewayEpinRequestHistory"
            element={<ProtectedRoute component={GatewayEpinRequestHistory} />}
          />
          <Route
            exact
            path="/CashbackIncomeHistory"
            element={<ProtectedRoute component={CashbackIncomeHistory} />}
          />
          <Route
            exact
            path="/CashbackIncomeRequest"
            element={<ProtectedRoute component={CashbackIncomeRequest} />}
          />
          <Route
            exact
            path="/News"
            element={<ProtectedRoute component={News} />}
          />
          <Route
            exact
            path="/UpdateLink"
            element={<ProtectedRoute component={UpdateLink} />}
          />
          <Route
            exact
            path="/ExpiredLink"
            element={<ProtectedRoute component={ExpiredLink} />}
          />
          <Route
            exact
            path="/GenerateLink"
            element={<ProtectedRoute component={GenerateLink} />}
          />
          <Route
            exact
            path="/GenerateLink500"
            element={<ProtectedRoute component={GenerateLink500} />}
          />
          <Route
            exact
            path="/GenerateLinkwithdrawal"
            element={<ProtectedRoute component={GenerateLinkwithdrawal} />}
          />
          <Route
            exact
            path="/GHRequesttoAdmin"
            element={<ProtectedRoute component={GHRequesttoAdmin} />}
          />
          <Route
            exact
            path="/PHRequesttoAdmin"
            element={<ProtectedRoute component={PHRequesttoAdmin} />}
          />
          <Route
            exact
            path="/UnusedPin"
            element={<ProtectedRoute component={UnusedPin} />}
          />
           <Route
            exact
            path="/EpinDetailsuserwise"
            element={<ProtectedRoute component={EpinDetailsuserwise} />}
          />
          <Route
            exact
            path="/UsedEpin"
            element={<ProtectedRoute component={UsedEpin} />}
          />
          <Route
            exact
            path="/GHRequestAdminHistory"
            element={<ProtectedRoute component={GHRequestAdminHis} />}
          />
          <Route
            exact
            path="/PHRequestAdminHistory"
            element={<ProtectedRoute component={PHRequestAdminHis} />}
          />
          <Route
            exact
            path="/LinkHistory"
            element={<ProtectedRoute component={LinkHistory} />}
          />
          <Route
            exact
            path="/WithdrawalLinkHistory"
            element={<ProtectedRoute component={WithdrawalLinkHistory} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
